<style scoped>
  .orders-table-header {
    border-bottom: 1px solid var(--color-border);
    padding-top: 10px;
    padding-bottom: 10px;
    padding-right: 5px;
    text-align: left;
    font-size: 12px;
    color: var(--color-text-dark);
  }
  .orders-table {
    border-collapse: collapse;
    width: 96%;
    margin-bottom: 20px;
    margin-left: 15px;
    /*margin-right: 15px;*/
    font-size: 12px;
  }
  .tablerow {
    /*background-color: #3a3d5a;*/
    height: 32px;
  }
  .oddrow {
    background-color: var(--color-accent-extra);
  }
  .symbol {
    display: flex;
    align-items: center;
    gap: 5px;
    font-size: 18px;
    font-weight: normal;
    padding-top: 5px;
    margin-left: 15px;
  }
  .bot-name {
    color: var(--color-text-dark);
    font-weight: bold;
    padding-bottom: 5px;
    font-size: 16px;
    margin-left: 15px;
  }
  .right-padding {
    padding-right: 5px;
  }
</style>

<template>
  <div>
    <Modal :value="show" width="800" @input="$emit('on-cancel', $event)">
      <div class="symbol">
        <CoinIcon :symbol="asset" />
        <span>{{ asset }}/USDT</span>
      </div>
      <table class="orders-table">
        <tr>
          <th class="orders-table-header">{{ $text.tr('ДАТА')}}</th>
          <th class="orders-table-header">{{ $text.tr('НАПРАВЛЕНИЕ')}}</th>
          <th class="orders-table-header">{{ $text.tr('КОЛ-ВО')}}</th>
          <th class="orders-table-header">{{ $text.tr('ЦЕНА')}}</th>
          <th class="orders-table-header">{{ $text.tr('СУММА')}}</th>
          <th class="orders-table-header">{{ $text.tr('КОМИССИЯ BINANCE')}}</th>
        </tr>
        <template v-for="(order, index) in orders">
          <tr :key="order.Id" class="tablerow" :class="{'oddrow': index % 2 === 0}">
            <td class="right-padding">
              {{ localTime(order.Executed) }}
            </td>
            <td class="right-padding">
              <div v-if="order.Side === 'B'" style="color: var(--color-success-light)">{{ $text.tr('покупка')}}</div>
              <div v-if="order.Side === 'S'" style="color:var(--color-danger-light)">{{ $text.tr('продажа')}}</div>
            </td>
            <td class="right-padding">
              {{ order.Qty }}
            </td>
            <td class="right-padding">
              {{ order.Price }}
            </td>
            <td class="right-padding">
              {{ returnAmount(order.Qty, order.Price) }}
            </td>
            <td>
              {{ order.Fee > 0 ? order.Fee + ' USDT' : order.FeeBnb + ' BNB'}}
            </td>
          </tr>
        </template>
      </table>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script lang="ts">
import CoinIcon from '@/components/common/CoinIcon.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Smartlimit } from '@/util/types'
import Decimal from 'decimal.js'

@Component({
  components: {
    CoinIcon
  }
})
export default class FastbotOrdersModal extends Vue {
  @Prop() private show!: boolean
  @Prop() private orders!: Smartlimit[]
  @Prop() private asset!: string

  returnAmount (qty: number, price: number) {
    const amount = new Decimal(qty).mul(new Decimal(price)).toDP(8).toString()
    return amount
  }

  localTime (utctime: string) {
    return new Date(utctime).toLocaleString('ru-RU').replace(',', '')
  }
}
</script>
